import { useKioskReconnect } from '../hooks/useKioskReconnect';

/**
 * Overlay shown when the API is disconnected in kiosk mode.
 * Displays a subtle "Reconnecting..." indicator at the bottom of the screen.
 * The page will automatically reload when the API comes back.
 */
export function KioskReconnectOverlay() {
  const { isKiosk, isDisconnected } = useKioskReconnect();

  if (!isKiosk || !isDisconnected) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-50">
      <div className="flex items-center gap-3 px-4 py-2 bg-gray-800/90 text-white rounded-full shadow-lg">
        <div className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse" />
        <span className="text-sm font-medium">Reconnecting...</span>
      </div>
    </div>
  );
}
